import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'

interface StatusBadgeProps {
    shadow?: boolean
    status: string
    styleOverrides?: CSSProperties
}

const statusStyles = css({
    borderBottomLeftRadius: 4,
    justifyContent: 'center',
    borderTopRightRadius: 4,
    alignItems: 'center',
    background: '#fff',
    fontWeight: 'bold',
    display: 'flex',
    width: '100%',
    color: '#333',
    opacity: 0.8,
})

const StatusBadge = memo((props: StatusBadgeProps) => {
    const { styleOverrides = {}, shadow, status } = props

    return (
        <div
            data-testid={`Badge__${status}`}
            css={statusStyles}
            style={{
                boxShadow: shadow ? `#333 0px 1px 2px` : null,
                ...styleOverrides,
            }}
        >
            {status}
        </div>
    )
})

export default StatusBadge
export { StatusBadge }
